(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products-custom"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(entries[0].target);

    const container = entries[0].target.querySelector('.related-proxy');
    if (!container) return;

    fetch(container.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('#related-products-section');
        if (recommendations && recommendations.innerHTML.trim().length > 0) {
          entries[0].target.innerHTML = recommendations.innerHTML;
        }
      });
  };

  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(document.querySelector('#related-products-section'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const initVideoGrid = () => {
      document.querySelectorAll('.video-grid__wrapper:not([data-initialized])').forEach(wrapper => {
        wrapper.setAttribute('data-initialized', 'true');
        wrapper.addEventListener('click', function() {
          const videoId = this.getAttribute('data-video-id');
          if (!videoId) return;

          const iframe = document.createElement('iframe');
          iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`);
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
          iframe.setAttribute('allowfullscreen', 'true');

          this.innerHTML = '';
          this.appendChild(iframe);
        });
      });
    };

    initVideoGrid();
    document.addEventListener('shopify:section:load', initVideoGrid);

    // «Leer más» en los títulos largos
    const revisarTitulos = () => {
      document.querySelectorAll('.video-grid__leer-mas').forEach(b => {
        const p = b.previousElementSibling;
        if (!p) return;
        if (p.classList.contains('is-expanded')) { b.hidden = false; return; }
        b.hidden = !(p.scrollHeight > p.clientHeight + 1);
      });
    };
    document.addEventListener('click', function(e) {
      const b = e.target.closest && e.target.closest('.video-grid__leer-mas');
      if (!b) return;
      e.preventDefault();
      const p = b.previousElementSibling;
      if (!p) return;
      const abierto = p.classList.toggle('is-expanded');
      b.textContent = abierto ? b.getAttribute('data-menos') : b.getAttribute('data-mas');
    });
    revisarTitulos();
    window.addEventListener('load', revisarTitulos);
    window.addEventListener('resize', revisarTitulos);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(revisarTitulos);
    document.addEventListener('shopify:section:load', revisarTitulos);
  });

  } catch(e) { console.error(e); }
})();
})();
